// extracted by mini-css-extract-plugin
module.exports = {"link":"style_link__2JI5C","active":"style_active__Om4iw","clicked":"style_clicked__8MXG5"};